import { ReactNative } from '@/api/app/react-native';

import * as Twilio from '@/api/calls/twilio';
import { AppNotification } from '@/api/app/app-notification';

interface SharedApi {
  getRememberToken: () => string;
  getSessionId: () => string;
  ReactNative: typeof ReactNative;
  Twilio: typeof Twilio;
  AppNotification: typeof AppNotification;
  muteIncomingCalls: typeof Twilio.muteIncomingCalls;
  unmuteIncomingCalls: typeof Twilio.unmuteIncomingCalls;
  toPhoneWav: (file: File) => Promise<File>;
}

declare global {
  interface Window {
    sharedApi: SharedApi;
  }
}

if (!window.sharedApi) {
  const getRememberToken = () => document.getElementById('remember_token')?.innerText;
  const getSessionId = () => document.getElementById('session_id')?.innerText;
  
  window.sharedApi = {
    getRememberToken,
    getSessionId,
    ReactNative,
    Twilio,
    AppNotification,
    muteIncomingCalls: Twilio.muteIncomingCalls,
    unmuteIncomingCalls: Twilio.unmuteIncomingCalls,
    // For the legacy greeting uploaders; loads the decoder only when something needs converting
    toPhoneWav: (file) => import('@/lib/amr').then((amr) => amr.toPhoneWav(file)),
  };
}
